/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_Faq_A2Inputs */

const en_guide_json_rest_api_faq_a2 = /** @type {(inputs: Guide_Json_Rest_Api_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For JSON data, yes. Some APIs also accept <code>text/json</code>, but <code>application/json</code> is the standard MIME type. For file uploads, use <code>multipart/form-data</code> instead.`)
};

const ko_guide_json_rest_api_faq_a2 = /** @type {(inputs: Guide_Json_Rest_Api_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 데이터의 경우 네. 일부 API는 <code>text/json</code>도 허용하지만, <code>application/json</code>이 표준 MIME 타입입니다. 파일 업로드의 경우 대신 <code>multipart/form-data</code>를 사용하세요.`)
};

const ja_guide_json_rest_api_faq_a2 = /** @type {(inputs: Guide_Json_Rest_Api_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONデータの場合は、はい。一部のAPIは<code>text/json</code>も受け付けますが、<code>application/json</code>が標準のMIMEタイプです。ファイルアップロードの場合は、代わりに<code>multipart/form-data</code>を使用してください。`)
};

/**
* | output |
* | --- |
* | "For JSON data, yes. Some APIs also accept <code>text/json</code>, but <code>application/json</code> is the standard MIME type. For file uploads, use <code>mu..." |
*
* @param {Guide_Json_Rest_Api_Faq_A2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_faq_a2 = /** @type {((inputs?: Guide_Json_Rest_Api_Faq_A2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_Faq_A2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_faq_a2(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_faq_a2(inputs)
	return ja_guide_json_rest_api_faq_a2(inputs)
});